import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AgentProvider } from './contexts/AgentContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Layout } from './components/Layout';
// Import new pages
import { OverviewPage } from './pages/OverviewPage';
import { PolicyPage } from './pages/PolicyPage';
import { ConoscenzaPage } from './pages/ConoscenzaPage';
import { StrumentiPage } from './pages/StrumentiPage';
import { WidgetsPage } from './pages/WidgetsPage';
import { StoricoPage } from './pages/StoricoPage';
import { CostiPage } from './pages/CostiPage';
import { UtentiPage } from './pages/UtentiPage';
import { AccountPage } from './pages/AccountPage';
import { ServizioDetailPage } from './pages/ServizioDetailPage';
import { AppAIPage } from './pages/AppAIPage';
import { ActionsPage } from './pages/ActionsPage';
import { ConsumiPage } from './pages/ConsumiPage';
import { ModelsPage } from './pages/ModelsPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ThemeProvider data-id="element-1">
        <AgentProvider data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Layout data-id="element-5" />} data-id="element-4">
              {/* Redirect root to overview */}
              <Route index element={<Navigate to="/overview" replace data-id="element-7" />} data-id="element-6" />

              {/* Main navigation pages */}
              <Route path="overview" element={<OverviewPage data-id="element-9" />} data-id="element-8" />
              <Route path="policy" element={<PolicyPage data-id="element-11" />} data-id="element-10" />
              <Route path="regole" element={<PolicyPage data-id="element-13" />} data-id="element-12" />

              {/* Servizi routes - NEW single detail page */}
              <Route path="servizi" element={<AppAIPage data-id="element-15" />} data-id="element-14" />
              <Route path="servizi/:agentId" element={<ServizioDetailPage data-id="element-17" />} data-id="element-16" />

              {/* Legacy app-ai routes - redirect to servizi */}
              <Route path="app-ai" element={<Navigate to="/servizi" replace data-id="element-19" />} data-id="element-18" />
              <Route path="app-ai/:agentId/*" element={<Navigate to="/servizi" replace data-id="element-21" />} data-id="element-20" />

              <Route path="conoscenza" element={<ConoscenzaPage data-id="element-23" />} data-id="element-22" />
              <Route path="knowledge" element={<ConoscenzaPage data-id="element-25" />} data-id="element-24" />
              <Route path="actions" element={<ActionsPage data-id="element-27" />} data-id="element-26" />
              <Route path="models" element={<ModelsPage data-id="element-29" />} data-id="element-28" />
              <Route path="consumi" element={<ConsumiPage data-id="element-31" />} data-id="element-30" />
              <Route path="strumenti" element={<StrumentiPage data-id="element-33" />} data-id="element-32" />
              <Route path="funzionalita" element={<StrumentiPage data-id="element-35" />} data-id="element-34" />
              <Route path="widgets" element={<WidgetsPage data-id="element-37" />} data-id="element-36" />
              <Route path="utenti" element={<UtentiPage data-id="element-39" />} data-id="element-38" />
              <Route path="storico" element={<StoricoPage data-id="element-41" />} data-id="element-40" />
              <Route path="costi" element={<CostiPage data-id="element-43" />} data-id="element-42" />
              <Route path="insights" element={<CostiPage data-id="element-45" />} data-id="element-44" />
              <Route path="account" element={<AccountPage data-id="element-47" />} data-id="element-46" />

              {/* Catch all - redirect to overview */}
              <Route path="*" element={<Navigate to="/overview" replace data-id="element-49" />} data-id="element-48" />
            </Route>
          </Routes>
        </AgentProvider>
      </ThemeProvider>
    </BrowserRouter>;
}